/**
 *
 *
 * @author fuyg
 * @date  2020-09-28
 */
import { createComponentBroadcast } from '../../common-scripts/componentBroadcast'
import ursLoginModal from './ursLoginModal'
import logger from '../../common-scripts/logger'
import ursComponentTab from '../urs-component-tab/ursComponentTab'

$('#close-btn').click(function() {
  const { actions } = ursLoginModal
  const modalBroadcast = createComponentBroadcast(ursLoginModal)
  modalBroadcast.trigger(actions.hide)

  const actionsTab = ursComponentTab.actions
  const componentTabBroadcast = createComponentBroadcast(ursComponentTab)
  componentTabBroadcast.trigger(actionsTab.initData)
})

$(function () {
  const { selector, actions } = ursLoginModal
  const $modal = $(selector)
  const modalBroadcast = createComponentBroadcast(ursLoginModal)

  modalBroadcast.on(actions.show, () => {
    logger.log('modalBroadcast show....')
    $modal.css({ 'z-index': 9999, opacity: 1 })
  })

  modalBroadcast.on(actions.hide, () =>{
    logger.log('modalBroadcast hide....')
    $modal.css({ 'z-index': -9999, opacity: 0 })
  })
})
